import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';
import { IDocumentUpdateParams } from '../../api/types';

type IuseDocumentUpdateProps = {
  id: string;
  data: IDocumentUpdateParams;
};

export const useDocumentUpdate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IuseDocumentUpdateProps) => {
      return await (await glynt).document.update(data.id, data.data);
    },

    ...callbacks
  });
};
